import { render, staticRenderFns } from "./OnHoldForm.vue?vue&type=template&id=77fc8299"
import script from "./OnHoldForm.vue?vue&type=script&lang=ts"
export * from "./OnHoldForm.vue?vue&type=script&lang=ts"
import style0 from "./OnHoldForm.vue?vue&type=style&index=0&id=77fc8299&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports